const insightsHubApiUrl = (<any>window).appenv;

type InsightHubResponse = {
  response_id: string;
  created_at: string;
  user_email: string;
  fk_form_id: string;
};

export class InsightHubService {
  static async getLatestFeedback(
    userId: string,
    formId: string
  ): Promise<InsightHubResponse | null | undefined> {
    const result = await fetch(
      `${insightsHubApiUrl.services.insightHubApi.baseurl}/${formId}/author/${userId}`,
      {headers: {'consumer-key': insightsHubApiUrl.insightsHubConsumerKey}}
    );
    const data: Array<InsightHubResponse> = await result.json();

    if (!data || data.length === 0) {
      return null;
    }

    return data.reduce((latest, current) => {
      return new Date(current.created_at) > new Date(latest.created_at)
        ? current
        : latest;
    });
  }
}
